export const createGridValues = (first: number, last: number, step: number) => {
  const arrayOfNumbers: Array<number> = [];
  for (let i = first; i < last; i += step) {
    arrayOfNumbers.push(i > first ? Math.floor(i / step) * step : i);
  }
  return arrayOfNumbers;
};
